(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports["default"] = void 0;var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));var Arc = /*#__PURE__*/function () {
  function Arc()


  {var breakpoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { md: 768, xl: 1280 };(0, _classCallCheck2["default"])(this, Arc);
    this.breakpoints = breakpoints;
    $(window).on('resize orientationchange', this.draw.bind(this));
    this.draw();
  }(0, _createClass2["default"])(Arc, [{ key: "draw", value: function draw()

    {
      var arr = [400, 60, 10];
      if (window.matchMedia("(min-width: ".concat(this.breakpoints.md, "px)")).matches) {
        arr = [400, 90, 15];
      } else if (window.matchMedia("(min-width: ".concat(this.breakpoints.xl, "px)")).matches) {
        arr = [400, 170, 20];
      }

      var canvas = document.querySelector('#canvas_arc');
      canvas.width = window.innerWidth * 2;
      canvas.height = 120;
      var ctx = canvas.getContext('2d');
      ctx.beginPath();
      ctx.moveTo(0, 50);
      for (var i = 1; i < arr[0]; i += 0.1) {
        var x = i * arr[1];
        var y = Math.sin(i) * arr[2] + 50;
        ctx.lineTo(x, y);
      }
      ctx.lineTo(window.innerWidth, 120);
      ctx.lineTo(0, 120);
      ctx.lineTo(0, 50);
      ctx.closePath();
      ctx.strokeStyle = "#f9f9f9";
      ctx.stroke();
      ctx.fillStyle = "#f9f9f9";
      ctx.fill();
    } }]);return Arc;}();exports["default"] = Arc;

},{"@babel/runtime/helpers/classCallCheck":10,"@babel/runtime/helpers/createClass":11,"@babel/runtime/helpers/interopRequireDefault":12}],2:[function(require,module,exports){
"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports["default"] = void 0;var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));var Carousel = /*#__PURE__*/function () {
  function Carousel()


  {var breakpoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { md: 768, xl: 1280 };(0, _classCallCheck2["default"])(this, Carousel);
    this.breakpoints = breakpoints;
    this.main();
  }(0, _createClass2["default"])(Carousel, [{ key: "main", value: function main()
    {
      // Slick -- 插件調用
      var trueOrFalse;
      if ($('body').attr('site_lang') === 'ar_SA' || $('body').attr('site_lang') === 'he_IL') {
        trueOrFalse = true;
      } else {
        trueOrFalse = false;
      }
      $('.carousel-box .carousel-list').each(function () {var _this = this;
        $(this).slick({
          lazyLoad: 'progressive',
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplaySpeed: 3000,
          infinite: true,
          autoplay: true,
          rtl: trueOrFalse,
          waitForAnimate: false, //  不等待animate执行结束
          dots: true,
          prevArrow: $(this).parents('.carousel-box').find('.slick-prev'),
          nextArrow: $(this).parents('.carousel-box').find('.slick-next') });


        $(window).on('resize orientationchange', function () {
          $(_this).slick('resize');
        });
      });
    } }]);return Carousel;}();exports["default"] = Carousel;

},{"@babel/runtime/helpers/classCallCheck":10,"@babel/runtime/helpers/createClass":11,"@babel/runtime/helpers/interopRequireDefault":12}],3:[function(require,module,exports){
"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports["default"] = void 0;var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));var Gotop = /*#__PURE__*/function () {
  function Gotop() {(0, _classCallCheck2["default"])(this, Gotop);
    this.$goTop = $('#go-top');
    this.$shareBox = $('#share');
    this.$goTop.on("click", function () {
      // 根據頁面高度和當前視口高度確定返回頂部所需時間，最小為 400
      var time = Math.max($("html, body").scrollTop() / ($(document).height() - $(window).height()), 0.4) * 1000;
      $("html, body").animate({
        scrollTop: 0 },
      time);
    });

    // 侧边栏分享智能隐藏
    this._headroom('#go-top');

    // 顶部下载按钮智能隐藏
    this._headroom('#top-bar');

    //滚动高度超过 1.4屏幕高度时显示 按钮
    this.scrollScreenHeight();
  }(0, _createClass2["default"])(Gotop, [{ key: "_headroom", value: function _headroom(
    selector) {
      var ele = document.querySelector(selector);
      new Headroom(ele).init();
    } }, { key: "scrollScreenHeight", value: function scrollScreenHeight()

    {var _this = this;
      $(window).on("scroll", function () {
        var winH = window.innerHeight;
        var scrollH = $(window).scrollTop();
        if (winH * 1.2 < scrollH) {
          _this.$goTop.fadeIn();
          _this.$shareBox.fadeIn();
        } else {
          _this.$goTop.fadeOut();
          _this.$shareBox.fadeOut();
        }
      });
    } }]);return Gotop;}();exports["default"] = Gotop;

},{"@babel/runtime/helpers/classCallCheck":10,"@babel/runtime/helpers/createClass":11,"@babel/runtime/helpers/interopRequireDefault":12}],4:[function(require,module,exports){
"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports["default"] = void 0;var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));var Image = /*#__PURE__*/function () {
  function Image()


  {var breakpoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { md: 768, xl: 1280 };(0, _classCallCheck2["default"])(this, Image);
    this.breakpoints = breakpoints;
    this.bLazy();
    this.renderImage();
    this.ImageScrollLazy();
  }(0, _createClass2["default"])(Image, [{ key: "bLazy", value: function bLazy()

    {
      new Blazy({
        breakpoints: [{
          width: this.breakpoints.md - 0.02,
          src: 'data-src-small' },

        {
          width: this.breakpoints.xl - 0.02,
          src: 'data-src-medium' }],


        loadInvisible: true,
        success: function success(element) {
          setTimeout(function () {
            var parent = element.parentNode;
            parent.className = parent.className.replace(/\bloading\b/, '');
          }, 200);
        } });

    } }, { key: "renderImage", value: function renderImage()

    {var _this = this;
      var src = '';
      var img_src = '';
      var $carouselItem = $('.carousel-item');

      this.ImgsrcChange($carouselItem, src, img_src);

      $(window).on('resize', function () {
        _this.ImgsrcChange($carouselItem, src, img_src);
      });

    } }, { key: "ImgsrcChange", value: function ImgsrcChange(

    $carouselItem, src, img_src) {var _this2 = this;
      $carouselItem.map(function (index, item) {
        src = $(item).data('mb-src');
        if (window.matchMedia("(min-width:".concat(_this2.breakpoints.md, "px)")).matches && (
        img_src = $(item).data('tab-src'))) {
          src = img_src;
        }
        if (window.matchMedia("(min-width:".concat(_this2.breakpoints.xl, "px)")).matches && (
        img_src = $(item).data('pc-src'))) {
          src = img_src;
        }
        src && $(item).attr('src', src);
      });
    } }, { key: "ImageScrollLazy", value: function ImageScrollLazy()

    {
      var $recommendsList = $('.recommend-list');
      var $Item = $recommendsList.find('.recommend-item');
      var on;
      $recommendsList.on('scroll', function () {
        if (on) return;
        $Item.map(function (index, el) {
          var $Img = $(el).find('img');
          if ($Img.data('src')) {
            $Img.attr('src', $Img.data('src'));
          }
        });
        on = true;
      });

    } }]);return Image;}();exports["default"] = Image;

},{"@babel/runtime/helpers/classCallCheck":10,"@babel/runtime/helpers/createClass":11,"@babel/runtime/helpers/interopRequireDefault":12}],5:[function(require,module,exports){
"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports["default"] = void 0;var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));var PageScroll = /*#__PURE__*/function () {
  function PageScroll() {(0, _classCallCheck2["default"])(this, PageScroll);
    this.scrollReveal();
  }

  //板块缓动动画
  (0, _createClass2["default"])(PageScroll, [{ key: "scrollReveal", value: function scrollReveal() {
      window.sr = ScrollReveal({
        origin: 'bottom',
        scale: 1,
        distance: '50px',
        easing: 'ease-in-out',
        nav_mobile: false,
        mobile: false,
        viewOffset: {
          top: 30,
          right: 0,
          bottom: 30,
          left: 0 } });



      var array = '.contuctus, .app-play, #recommends, .kingdom-songs, .create-songs-list, .classify-songs, .local-abouchement, .img-box,  .mobile-model, .wonderful-movie, .mobile-small,.carousel-box, .online-talk .section-title,.online-talk .description, .question-item, .app-rwm, .footer-top, .footer-bottom,.copright';
      sr.reveal(array, {
        duration: 600,
        delay: 320 });


      //第一屏图片展示动画
      $('.recommend-item').map(function (i, el) {
        sr.reveal($(el), {
          duration: 600,
          delay: 120 * i,
          distance: '3em' });

      });

      //首屏其他动画
      sr.reveal('.title', {
        origin: 'right',
        distance: '3em' });

      sr.reveal('.sub-title', {
        origin: 'left',
        distance: '3em' });


      //常见问题 列表动画
      $('.question-item').map(function (i, el) {
        sr.reveal($(el), {
          duration: 600,
          delay: 80 * i,
          distance: '3em' });

      });
      // 各板块大标题及描述动画
      sr.reveal('.feature .section-title', {
        duration: 600,
        origin: 'right',
        delay: 800 });


      sr.reveal('.feature .description', {
        duration: 600,
        origin: 'right',
        delay: 1000 });


      sr.reveal('.container.align-center .section-title', {
        duration: 600 });


      sr.reveal('.container.align-center .description, .ratio-online-talk-img ', {
        duration: 600,
        delay: 200 });


      //板块4 凸起部分
      sr.reveal('.cover-wrapper', {
        delay: 800,
        scale: 0.85 });



      //手机动画
      sr.reveal('.mobile', {
        duration: 600,
        delay: 440 });



    } }]);return PageScroll;}();exports["default"] = PageScroll;

},{"@babel/runtime/helpers/classCallCheck":10,"@babel/runtime/helpers/createClass":11,"@babel/runtime/helpers/interopRequireDefault":12}],6:[function(require,module,exports){
"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports["default"] = void 0;var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));var Question = /*#__PURE__*/function () {
  function Question() {(0, _classCallCheck2["default"])(this, Question);
    this.init();
  }(0, _createClass2["default"])(Question, [{ key: "init", value: function init()
    {
      $('.question-title').on('click', function () {
        // 为了一点点优化
        if ($(this).hasClass('active')) {
          $(this).removeClass('active').
          parent().
          children('.question-body').stop().slideUp(300);
        } else {
          // 移除所有激活项 收起内容
          $('.question-item').
          children('.question-title').removeClass('active').
          end().
          children('.question-body').stop().slideUp(300);

          // 激活当前项 展开内容
          $(this).addClass('active').
          siblings('.question-body').stop().slideDown(300);
        }
      });
    } }]);return Question;}();exports["default"] = Question;

},{"@babel/runtime/helpers/classCallCheck":10,"@babel/runtime/helpers/createClass":11,"@babel/runtime/helpers/interopRequireDefault":12}],7:[function(require,module,exports){
"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports["default"] = void 0;var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));var Video = /*#__PURE__*/function () {
  function Video() {(0, _classCallCheck2["default"])(this, Video);
    // 頭部視頻彈窗
    this.videoLity();
  }(0, _createClass2["default"])(Video, [{ key: "videoLity", value: function videoLity()

    {
      // $('#video_mask').on('click', function () {
      //     let videoSrc = $(this).data('videoSrc')
      //     window.__lity = window.lity(videoSrc);
      // })

      var video = document.querySelector('.iphoneVideo video');
      video.controls = false;
    } }]);return Video;}();exports["default"] = Video;

},{"@babel/runtime/helpers/classCallCheck":10,"@babel/runtime/helpers/createClass":11,"@babel/runtime/helpers/interopRequireDefault":12}],8:[function(require,module,exports){
"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports["default"] = void 0;var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));var Wave =

function Wave(id) {(0, _classCallCheck2["default"])(this, Wave);
  var W = {};

  /*========================================
              Utility
              ========================================*/

  W.rand = function (min, max) {
    if (!max) {
      var max = min;
      min = 0;
    }

    return Math.random() * (max - min) + min;
  };

  /*========================================
     Initialize
     ========================================*/

  W.init = function () {
    W.c = document.querySelector(id);
    W.ctx = W.c.getContext('2d');
    W.simplex = new SimplexNoise();
    W.events();
    W.reset();
    W.loop();
  };

  /*========================================
     Reset
     ========================================*/

  W.reset = function () {
    W.w = window.innerWidth;
    // W.h = window.innerHeight;
    W.h = 220;
    W.cx = W.w / 2;
    W.cy = W.h / 2;
    W.c.width = W.w;
    W.c.height = W.h;

    W.count = Math.floor(W.w / W.rand(15, 22)); // Wave frequency
    W.xoff = 0;
    W.xinc = 0.05;
    W.yoff = 0;
    W.yinc = 0.008; // Speed
    W.goff = 0;
    W.ginc = 0;
    W.y = W.h * 0.65;
    W.length = W.w + 0;
    W.amp = 50; // Wave height
  };

  /*========================================
     Event
     ========================================*/

  W.events = function () {
    window.addEventListener('resize', W.reset.bind(undefined));
  };

  /*========================================
     Wave
     ========================================*/

  W.wave = function (color, amp, height, comp) {
    W.ctx.beginPath();
    var sway = W.simplex.noise2D(W.goff, 0) * amp;

    for (var i = 0; i <= W.count; i++) {
      W.xoff += W.xinc;
      var x = W.cx - W.length / 2 + W.length / W.count * i;
      var y = height + W.simplex.noise2D(W.xoff, W.yoff) * amp + sway;
      W.ctx[i === 0 ? 'moveTo' : 'lineTo'](x, y);
    }

    W.ctx.lineTo(W.w, -W.h); // -W.h - Vertically reflection
    W.ctx.lineTo(0, -W.h); // -W.h - Vertically reflection
    W.ctx.closePath();
    W.ctx.fillStyle = color;

    if (comp) {
      W.ctx.globalCompositeOperation = comp;
    }

    W.ctx.fill();
  };

  /*========================================
     Loop
     ========================================*/

  W.loop = function () {
    requestAnimationFrame(W.loop);

    W.ctx.clearRect(0, 0, W.w, W.h);
    W.xoff = 0;

    W.wave("rgba(232, 71, 85, 0.2)", 30, W.h * .65, "screen");
    W.wave("rgba(250, 207, 158, 0.25)", 30, W.h * .65, "screen");

    // W.ctx.fillStyle = "#e8475500";

    // W.ctx.globalCompositeOperation = "darken";

    // W.ctx.fillRect(0, 0, W.w, W.h);

    W.yoff += W.yinc;
    W.goff += W.ginc;
  };

  /*========================================
     Start
     ========================================*/

  W.init();
};exports["default"] = Wave;

},{"@babel/runtime/helpers/classCallCheck":10,"@babel/runtime/helpers/interopRequireDefault":12}],9:[function(require,module,exports){
"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");var _GoTop = _interopRequireDefault(require("./Modules/GoTop"));
var _Image = _interopRequireDefault(require("./Modules/Image"));
var _Carousel = _interopRequireDefault(require("./Modules/Carousel"));
var _Question = _interopRequireDefault(require("./Modules/Question"));
var _Video = _interopRequireDefault(require("./Modules/Video"));
var _Wave = _interopRequireDefault(require("./Modules/Wave"));
var _Arc = _interopRequireDefault(require("./Modules/Arc"));
var _PageScroll = _interopRequireDefault(require("./Modules/PageScroll"));

!function () {
  // banner 视频弹窗
  new _Video["default"]();

  // 轮播图
  new _Carousel["default"]();

  // 加载图片
  new _Image["default"]();

  // 返回顶部
  new _GoTop["default"]();
  // 常见问题
  new _Question["default"]();
  // 水波效果
  new _Wave["default"]('#section-wave');
  new _Arc["default"]();
  new _Wave["default"]('#footer-wave');
  // 页面滚动
  new _PageScroll["default"]();
}();

},{"./Modules/Arc":1,"./Modules/Carousel":2,"./Modules/GoTop":3,"./Modules/Image":4,"./Modules/PageScroll":5,"./Modules/Question":6,"./Modules/Video":7,"./Modules/Wave":8,"@babel/runtime/helpers/interopRequireDefault":12}],10:[function(require,module,exports){
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
},{}],11:[function(require,module,exports){
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
},{}],12:[function(require,module,exports){
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
},{}]},{},[9])

//# sourceMappingURL=index.js.map
